import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Mail, Phone, User, Building2 } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import { companyInfo } from '../mock';

const ContactModal = ({ isOpen, onClose }) => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission
    console.log('Contact form submitted:', formData);
    toast({
      title: 'Message Sent!',
      description: `We'll get back to you soon at ${formData.email}`,
    });
    setFormData({ name: '', email: '', company: '', phone: '', message: '' });
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px] bg-[#2a2a2a] text-white border-[#4a4a4a]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-white">Contact Us</DialogTitle>
          <DialogDescription className="text-[#a0a0a0]">
            Get in touch with our wholesale team. We'll respond within 24 hours.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="flex items-center gap-3 text-sm text-[#a0a0a0]">
            <Mail className="w-4 h-4" />
            <span>{companyInfo.email}</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-[#a0a0a0]">
            <Phone className="w-4 h-4" />
            <span>WhatsApp: {companyInfo.whatsapp}</span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="name" className="text-white">Full Name *</Label>
              <div className="relative">
                <User className="absolute left-3 top-3 h-4 w-4 text-[#a0a0a0]" />
                <Input
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="pl-10 bg-[#1a1a1a] border-[#4a4a4a] text-white focus:border-white"
                  placeholder="John Doe"
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="email" className="text-white">Email *</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-3 h-4 w-4 text-[#a0a0a0]" />
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="pl-10 bg-[#1a1a1a] border-[#4a4a4a] text-white focus:border-white"
                  placeholder="john@example.com"
                />
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="company" className="text-white">Company</Label>
              <div className="relative">
                <Building2 className="absolute left-3 top-3 h-4 w-4 text-[#a0a0a0]" />
                <Input
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="pl-10 bg-[#1a1a1a] border-[#4a4a4a] text-white focus:border-white"
                  placeholder="Your Company"
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="phone" className="text-white">Phone</Label>
              <div className="relative">
                <Phone className="absolute left-3 top-3 h-4 w-4 text-[#a0a0a0]" />
                <Input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  className="pl-10 bg-[#1a1a1a] border-[#4a4a4a] text-white focus:border-white"
                  placeholder="+971 XXX XXXX"
                />
              </div>
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="message" className="text-white">Message *</Label>
            <Textarea
              id="message"
              name="message"
              required
              value={formData.message}
              onChange={handleChange}
              className="min-h-[120px] bg-[#1a1a1a] border-[#4a4a4a] text-white focus:border-white"
              placeholder="Tell us about your wholesale needs..."
            />
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="submit"
              className="flex-1 bg-white text-black hover:bg-[#e5e5e5] font-semibold"
            >
              Send Message
            </Button>
            <Button
              type="button"
              onClick={onClose}
              variant="outline"
              className="flex-1 border-[#4a4a4a] text-white hover:bg-[#3a3a3a]"
            >
              Cancel
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ContactModal;
